import { applyMiddleware, createStore, compose } from 'redux';
import { thunk } from 'redux-thunk';
import reducers from './reducers';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const rootReducer = reducers;
export const middleware = [thunk];

export default createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));
